import { CallcardStampsService } from '@addins/core/journal';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SagaObject } from '@models/imported/SagaBase/SagaObject';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { List } from '@models/list';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-callcard-journal',
  templateUrl: './callcard-journal.component.html',
  styleUrls: ['./callcard-journal.component.scss']
})
export class CallcardJournalComponent implements OnInit, OnDestroy {
  @Input() callcard: CallCard;

  private _callcardStamps: List<SagaObject> = null;
  get journalItems(): SagaObject[] {
    return (this._callcardStamps && this._callcardStamps.items) || [];
  }

  private refreshSub: Subscription;

  constructor(private callcardStamps: CallcardStampsService) {}

  ngOnInit() {
    this.getStamps();
    this.refreshSub = this.callcardStamps.$refreshStamps.subscribe(() => this.getStamps(true));
  }

  private getStamps(refresh?: boolean) {
    this.callcardStamps.getStamps(this.callcard, refresh).subscribe(list => (this._callcardStamps = list));
  }

  ngOnDestroy() {
    this.refreshSub?.unsubscribe();
  }
}
